import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5symgoahr8: FaireBrandEntity = {
  token: "b_5symgoahr8",
  type: "brand",
  name: "Girl Tribe Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/c9f75cb28f83be0096c094e0794530937857f492bbc408ff03d426385c60141b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/05c65c7ec3ef6c10a5ea07f453a03a9319d6b0fc3c1fb8b1beff72ddd5ab42b6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c9f75cb28f83be0096c094e0794530937857f492bbc408ff03d426385c60141b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/05c65c7ec3ef6c10a5ea07f453a03a9319d6b0fc3c1fb8b1beff72ddd5ab42b6.jpeg",
  location: "Charlotte, NC, USA",
  minimumOrderDollars: 150,
  rating: 4.6,
  reviewCount: 123,
  isInsider: true,
  description:
    "Created by childhood best friends Carrie and Sarah, Girl Tribe began in 2014 as a place to tell our story and our love for all things pop culture, bff related and pink! Our graphic tees are printed at our production facility in Charlotte, NC and we currently sell to hundreds of stores across the US. Mahjong and Games!",
  meta: {
    source: "api",
    importedAt: "2026-07-17T22:00:34.254Z",
    importedBy: "entity-db-cli",
  },
};
